import { AutoLogout } from '@backstage/core-components'
import { apiDocsPlugin, ApiExplorerPage } from '@backstage/plugin-api-docs'
import { CatalogEntityPage, CatalogIndexPage, catalogPlugin, } from '@backstage/plugin-catalog'
import { CatalogImportPage, catalogImportPlugin, } from '@backstage/plugin-catalog-import'
import { orgPlugin } from '@backstage/plugin-org'
import { ScaffolderPage, scaffolderPlugin } from '@backstage/plugin-scaffolder'
import { SearchPage } from '@backstage/plugin-search'
import { TechDocsIndexPage, techdocsPlugin, TechDocsReaderPage, } from '@backstage/plugin-techdocs'
import { ReportIssue } from '@backstage/plugin-techdocs-module-addons-contrib'
import { TechDocsAddons } from '@backstage/plugin-techdocs-react'
import { UserSettingsPage } from '@backstage/plugin-user-settings'
import { Mermaid } from 'backstage-plugin-techdocs-addon-mermaid'
import { Navigate, Route } from 'react-router-dom'
import { apis } from './apis'
import { entityPage } from './components/catalog/EntityPage'
import { Root } from './components/Root'
import { searchPage } from './components/search/SearchPage'

import { createApp } from '@backstage/app-defaults'
import { AppRouter, FlatRoutes } from '@backstage/core-app-api'
import { AlertDisplay, OAuthRequestDialog, SignInPage, } from '@backstage/core-components'
import { githubAuthApiRef } from '@backstage/core-plugin-api'
import { catalogEntityCreatePermission } from '@backstage/plugin-catalog-common/alpha'
import { CatalogGraphPage } from '@backstage/plugin-catalog-graph'
import { RequirePermission } from '@backstage/plugin-permission-react'

const isProduction = process.env.NODE_ENV === 'production';

const loginProviders = [
   ...(isProduction ? [] : ['guest' as const]),
  {
    id: 'github',
    title: 'GitHub',
    message: 'Sign in using GitHub',
    apiRef: githubAuthApiRef,
  }
]


const app = createApp({
  apis,
  bindRoutes({ bind }) {
    bind(catalogPlugin.externalRoutes, {
      createComponent: scaffolderPlugin.routes.root,
      viewTechDoc: techdocsPlugin.routes.docRoot,
      createFromTemplate: scaffolderPlugin.routes.selectedTemplate,
    });
    bind(apiDocsPlugin.externalRoutes, {
      registerApi: catalogImportPlugin.routes.importPage,
    });
    bind(scaffolderPlugin.externalRoutes, {
      registerComponent: catalogImportPlugin.routes.importPage,
      viewTechDoc: techdocsPlugin.routes.docRoot,
    });
    bind(orgPlugin.externalRoutes, {
      catalogIndex: catalogPlugin.routes.catalogIndex,
    });
  },
  components: {
    SignInPage: props => (
      <SignInPage
        {...props}
        auto
        providers={loginProviders}
      />
    ),
  },
});

const routes = (
  <FlatRoutes>
    <Route path="/" element={<Navigate to="catalog" />} />
    <Route path="/catalog" element={<CatalogIndexPage />} />
    <Route
      path="/catalog/:namespace/:kind/:name"
      element={<CatalogEntityPage />}
    >
      {entityPage}
    </Route>
    <Route path="/docs" element={<TechDocsIndexPage />} />
    <Route
      path="/docs/:namespace/:kind/:name/*"
      element={<TechDocsReaderPage />}
    >
      <TechDocsAddons>
        <ReportIssue />
        <Mermaid />
      </TechDocsAddons>
    </Route>
    <Route path="/create" element={<ScaffolderPage />} />
    <Route path="/api-docs" element={<ApiExplorerPage />} />
    <Route
      path="/catalog-import"
      element={
        <RequirePermission permission={catalogEntityCreatePermission}>
          <CatalogImportPage />
        </RequirePermission>
      }
    />
    <Route path="/search" element={<SearchPage />}>
      {searchPage}
    </Route>
    <Route path="/settings" element={<UserSettingsPage />} />
    <Route path="/catalog-graph" element={<CatalogGraphPage />} />
  </FlatRoutes>
);

export default app.createRoot(
  <>
    <AlertDisplay />
    <OAuthRequestDialog />
    <AutoLogout />
    <AppRouter>
      <Root>{routes}</Root>
    </AppRouter>
  </>,
);
